export default "__VITE_ASSET__DtFr3zS$__"